import React from "react";
import { ReactComponent as Search } from "../Global Icons/Search.svg";
import calanderImg from "../Global Icons/calander.png";
import { Link } from "react-router-dom";
// import { ReactComponent as SearchButton } from "../Global Icons/SearchButtonList.svg";
import { ReactComponent as SearchButton } from "../Global Icons/SearchIconW.svg";
import { FaFileExcel, FaDownload } from 'react-icons/fa';
import "./listTopSearch.css"

const ListTopSearch = ({
  h3heading,
  setState,
  buttonhead,
  navigateTo,
  buttonhead2,
  onPressEnter,
  navigateTo2,
  filterFunction,
  onCalendarClick,
  onDownload,
  onDownloadUser,
  onDownloadProject,
  onDownloadBooking,
}) => {
  return (
    <div className="topbar-search_main">
      <div className="topbar-search">
        <div>
          <h3 style={{ fontSize: "20px", fontWeight: 400 }}>{h3heading}</h3>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "60%",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div className="outer-input-search">
            <Search className="search-icon" />
            {/* <input
              type="text"
              placeholder="Search"
              className="search-class"
              onChange={(event) => setState(event.target.value.toLowerCase())}
            /> */}
            <input
              type="text"
              placeholder="Search"
              className="search-class"
              onChange={(event) => setState(event.target.value.toLowerCase())}
              onKeyDown={(e) => e.key === 'Enter' && onPressEnter?.()}  // ✅ Add this line
            />
          </div>
          <div className="clander-button" onClick={onCalendarClick}>
            <img src={calanderImg} alt="Calendar" style={{ height: "25px" }} />
          </div>
          <div className="search-button" onClick={filterFunction}>
            <SearchButton />
          </div>
        </div>
        <div style={{ display: "flex", gap: "12px", zIndex: 10 }}>
          <Link to={`${navigateTo}`}>
            {buttonhead ? <button className="button-class">{buttonhead}</button> : null}
          </Link>
          <Link to={`${navigateTo2}`}>
            {buttonhead2 ? <button className="button-class">{buttonhead2}</button> : null}
          </Link>
          {/* Download button placed alongside buttonhead2 */}
          {onDownload && (
            <button
              onClick={onDownload}
              className="excel-download-btn"
              title="Download Excel Report"
              aria-label="Download Excel Report"
            >
              <div className="icon-wrapper">
                <FaFileExcel className="excel-icon" size={20} />
                <FaDownload className="download-icon" size={10} />
              </div>
            </button>
          )}
          {onDownloadBooking && (
            <button
              onClick={onDownloadBooking}
              className="excel-download-btn"
              title="Download Excel Report"
              aria-label="Download Excel Report"
            >
              <div className="icon-wrapper">
                <FaFileExcel className="excel-icon" size={20} />
                <FaDownload className="download-icon" size={10} />
              </div>
            </button>
          )}
          {onDownloadUser && (
            <button
              onClick={onDownloadUser}
              className="excel-download-btn"
              title="Download Excel Report"
              aria-label="Download Excel Report"
            >
              <div className="icon-wrapper">
                <FaFileExcel className="excel-icon" size={20} />
                <FaDownload className="download-icon" size={10} />
              </div>
            </button>
          )}
          {onDownloadProject && (
            <button
              onClick={onDownloadProject}
              className="excel-download-btn"
              title="Download Excel Report"
              aria-label="Download Excel Report"
            >
              <div className="icon-wrapper">
                <FaFileExcel className="excel-icon" size={20} />
                <FaDownload className="download-icon" size={10} />
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListTopSearch;
